import * as nls from 'vscode-nls/lib/main';
import { IConfigurationNode, ConfigurationScope, IConfigurationRegistry } from '../interfaces';
import { ExtensionMessageCollector } from '@workbench-stack/extensions';
import { OVERRIDE_PROPERTY_PATTERN, Extensions } from '../constants';
import { Registry } from '@workbench-stack/platform';

const localize = nls.loadMessageBundle();

export function validateProperties(configuration: IConfigurationNode, collector: ExtensionMessageCollector): void {
    let properties = configuration.properties;
    if (properties) {
        if (typeof properties !== 'object') {
            collector.error(localize('invalid.properties', "'configuration.properties' must be an object"));
            configuration.properties = {};
        }
        for (let key in properties) {
            const message = validateProperty(key);
            const propertyConfiguration = configuration.properties[key];
            propertyConfiguration.scope = propertyConfiguration.scope && propertyConfiguration.scope.toString() === 'resource' ? ConfigurationScope.RESOURCE : ConfigurationScope.WINDOW;
            if (message) {
                collector.warn(message);
                delete properties[key];
            }
        }
    }
    let subNodes = configuration.allOf;
    if (subNodes) {
        for (let node of subNodes) {
            validateProperties(node, collector);
        }
    }
}

const configurationRegistry = Registry.Instance.as<IConfigurationRegistry>(Extensions.Configuration);
export function validateProperty(property: string): string {
    if (OVERRIDE_PROPERTY_PATTERN.test(property)) {
        return localize('config.property.languageDefault',
            "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", property);
    }
    if (configurationRegistry.getConfigurationProperties()[property] !== void 0) {
        return localize('config.property.duplicate', "Cannot register '{0}'. This property is already registered.", property);
    }
    return null;
}
